import { ImagesMobile } from '@/assets/images';
import { Button } from '@/components/';
import { cn } from '@/utils';
import { CloseOutlined } from '@ant-design/icons';
import { memo } from 'react';

import { Modal as AntModal, ModalProps as AntModalProps, Spin } from 'antd';

import './style.scss';

interface ModalProps extends AntModalProps {
	children: React.ReactNode;
	labelButton?: string;
	isDisabledButton?: boolean;
	onClickButton?: (e: React.MouseEvent<any>) => void;
	classNameBtnContainer?: string;
	classNameBtn?: string;
	classNameTitle?: string;
	isShowIconCloseBlack?: boolean;
}

const Modal = ({
	children,
	title = '',
	labelButton = '',
	isDisabledButton = false,
	onClickButton = () => null,
	classNameBtnContainer,
	classNameBtn,
	width = 1320,
	maskClosable = false,
	loading = false,
	classNameTitle,
	isShowIconCloseBlack,
	prefixCls,
	...props
}: ModalProps) => {
	return (
		<AntModal
			title={
				<div
					className={`text-[14px] font-bold text-white h-[40px] pl-5 flex items-center bg-blue7 ${classNameTitle}`}
				>
					{title}
				</div>
			}
			{...props}
			centered
			footer={false}
			prefixCls={prefixCls ?? 'common-modal'}
			width={width}
			maskClosable={maskClosable}
			classNames={{
				...props.classNames,
				content: cn(
					'[&>.common-modal-close]:!top-[4px] !rounded-none',
					props.classNames?.content
				),
			}}
			closeIcon={
				isShowIconCloseBlack ? (
					<img
						src={ImagesMobile.iconCloseModal}
						className="w-[24px] h-[24px]"
					/>
				) : (
					<CloseOutlined className="text-white" style={{ fontSize: '16px' }} />
				)
			}
		>
			<Spin spinning={loading}>
				{children}
				{labelButton && (
					<div
						className={cn('flex justify-center mt-10', classNameBtnContainer)}
					>
						<Button
							type="primary"
							className={cn(classNameBtn)}
							disabled={isDisabledButton}
							onClick={onClickButton}
							isMainBtn
						>
							{labelButton}
						</Button>
					</div>
				)}
			</Spin>
		</AntModal>
	);
};

export default memo(Modal);
